import HttpClient from "@/infra/HttpClient";

export default class RequestsService {

    constructor (readonly httpClient: HttpClient, readonly baseUrl: string) {
    }

    async getRequests (idService: number) {
        return this.httpClient.get(`${this.baseUrl}/services/${idService}/requests`);
    }

	async getLogs (idService: number, idRequest: number) {
        return this.httpClient.get(`${this.baseUrl}/services/${idService}/requests/${idRequest}/logs`);
    }

	async getLog (idService: number, idRequest: number, idRequestLog: number) {
        return this.httpClient.get(`${this.baseUrl}/services/${idService}/requests/${idRequest}/logs/${idRequestLog}`);
    }
}
